@use '../@shared/mixins' as *;
@use '../../styles/global' as *;

@layer kol-component {
	.kol-skip-nav {
		&__list {
			display: grid;
			place-items: center;
			list-style: none;
		}

		&__list-item {
			height: 0;
		}

		.kol-link {
			position: absolute;
			left: to-rem(-99999);
			z-index: 9999999;

			line-height: 1;

			&:focus {
				background-color: #fff;
				position: unset;
				left: unset;
			}
		}
	}
}
